import { ApiUtils, UrlUtils } from '@vectord/utils';

function apiRequest(method, path, ...args) {
  return ApiUtils.request(
    method,
    UrlUtils.join(process.env.REACT_APP_API_BASE, path),
    ...args
  );
}

export default apiRequest;
